import styled from 'styled-components';

import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { ValueRendererProps } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';

const StyledList = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0;

   > li:after {
      content: ',';
   }
   > li:last-child:after {
      content: '';
   }
`;

const AuthorizationCell = (props: ValueRendererProps<MedicalDataAccessAuthorization, boolean>): JSX.Element | null => {
   const { forDocumentation, forInformation } = props.bean;
   const translate = useTranslate();
   if (!forDocumentation && !forInformation) {
      return null;
   }

   return (
      <StyledList>
         {forDocumentation ? (
            <li>
               {translate(patientConsentsAndAuthorizationsTranslationKeys.authorizations.table.medicalDocumentation)}
            </li>
         ) : null}
         {forInformation ? (
            <li>
               {translate(patientConsentsAndAuthorizationsTranslationKeys.authorizations.table.medicalInformation)}
            </li>
         ) : null}
      </StyledList>
   );
};

export { AuthorizationCell };
